import { render, staticRenderFns } from "./TheFotter.vue?vue&type=template&id=64823b60&scoped=true&"
import script from "./TheFotter.vue?vue&type=script&lang=js&"
export * from "./TheFotter.vue?vue&type=script&lang=js&"
import style0 from "./TheFotter.vue?vue&type=style&index=0&id=64823b60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64823b60",
  null
  
)

component.options.__file = "TheFotter.vue"
export default component.exports